;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();const encodeBase64 = (base64string: string) => {
  const signaturePosition = base64string.indexOf('base64,');

  return signaturePosition > -1 ? base64string.substring(signaturePosition + 7) : base64string;
};

export default encodeBase64;
